import React from "react";
import { cn } from "../../lib/utils";

const Switch = React.forwardRef(function Switch(
  { checked = false, onCheckedChange, disabled = false, className, ...props },
  ref
) {
  const handleToggle = () => {
    if (!disabled && typeof onCheckedChange === "function") {
      onCheckedChange(!checked);
    }
  };

  return (
    <button
      ref={ref}
      type="button"
      dir="ltr"
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
      data-state={checked ? "checked" : "unchecked"}
      disabled={disabled}
      onClick={handleToggle}
      className={cn(
        "relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center overflow-hidden rounded-full border border-transparent p-[2px] transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-1",
        checked ? "bg-brand" : "bg-[#c8c8c8]",
        disabled && "cursor-not-allowed opacity-60",
        className
      )}
      {...props}
    >
      <span
        className="switch-thumb pointer-events-none block h-5 w-5 shrink-0 rounded-full bg-white shadow transition-transform"
      />
    </button>
  );
});

export { Switch };
